__turbopack_context__.v({
  "menuTrigger": "vDSHNW_menuTrigger" + " " + "header-menu-trigger",
});
